export enum OverloadedContentActionTypes {
  CLOSED = 'overloaded-content/CLOSED',
  OPENED = 'overloaded-content/OPENED',
  WRAPPER_PROPS_UPDATED = 'overloaded-content/WRAPPER_PROPS_UPDATED',
}
